
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.688 2.313h3.937a.75.75 0 01.75.75v15.562a.75.75 0 01-.75.75H1.375a.75.75 0 01-.75-.75V3.062a.75.75 0 01.75-.75h3.938v-1.5c0-.103.084-.187.187-.187h1.313c.103 0 .187.084.187.188v1.5h6v-1.5c0-.104.084-.188.188-.188H14.5c.103 0 .188.084.188.188v1.5zM2.312 17.687h15.376V8.781H2.313v8.906zM2.313 4v3.188h15.376V4h-3v1.125a.188.188 0 01-.188.188h-1.313A.188.188 0 0113 5.125V4H7v1.125a.188.188 0 01-.188.188H5.5a.188.188 0 01-.188-.188V4h-3zm7.526 6.25l2.951 2.56a.253.253 0 01.064.294.253.253 0 01-.064.085l-2.97 2.577a.06.06 0 01-.04.015h-.716a.062.062 0 01-.04-.11l2.736-2.374H7.187a.063.063 0 01-.062-.063v-.468c0-.035.028-.063.063-.063h4.571l-2.736-2.375a.062.062 0 01.041-.11h.691c.03 0 .06.012.082.031z"}})])
          )
        }
      }
    